module.exports = __webpack_public_path__ + "static/assets/81cc9d445b108e39daed9176ea5f77eb.svg";